module.exports = __webpack_public_path__ + "520586c6596810ccdd1aa6207287d914.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/ball-tennis-racket.png
// module id = 2975
// module chunks = 0